import moment from "moment";
import { FC } from "react";
import _ from "lodash";
import {StatusBadge, Avatar} from "components/core";

interface ClickupTaskViewProps {
  task: {
    id: string,
    name: string,
    status: string,
    date_created: Date,
    date_closed: Date,
    date_done: Date,
    creator: {
      email: string,
      id: string,
      profilePicture?: string,
      username: string,
    }
    tags: {
      name: string,
      tag_bg: string,
      tag_fg: string,
    }
    priority: {
      color: string,
      priority: string
    }
    project: {
      id: string,
      name: string
    }
  }
}

export const ClickupTaskView: FC<ClickupTaskViewProps> = ({ task }) => {
  return (
    <dl className="grid grid-cols-1 gap-x-4 gap-y-8 sm:grid-cols-3 p-6 overflow-y-auto">
      <div className="sm:col-span-1">
        <dt className="text-sm font-medium text-gray-500">Ticket ID</dt>
        <dd className="mt-1 text-sm text-gray-900">{task?.id || "N/A"}</dd>
      </div>
      <div className="sm:col-span-2">
        <dt className="text-sm font-medium text-gray-500">Name</dt>
        <dd className="mt-1 text-sm text-gray-900">
          {_.startCase(task?.name) || "N/A"}
        </dd>
      </div>
      <div className="sm:col-span-1">
        <dt className="text-sm font-medium text-gray-500">Status</dt>
        <dd className="mt-1 text-sm text-gray-900">
          {_.startCase(task?.status) || "N/A"}
        </dd>
      </div>
      <div className="sm:col-span-1">
        <dt className="text-sm font-medium text-gray-500">Priority</dt>
        <dd className="mt-1 text-sm text-gray-900">
          { task?.priority?.priority
            ? <StatusBadge
              status={task?.priority?.priority}
              options={{
                [task?.priority?.priority]: `!text-[${task?.priority.color}]`
              }} />
            : "N/A"}
        </dd>
      </div>
      <div className="sm:col-span-1">
        <dt className="text-sm font-medium text-gray-500">Escalated At</dt>
        <dd className="mt-1 text-sm text-gray-900">
          { task?.date_created
            ? moment(Number(task?.date_created)).format("DD/MM/YYYY hh:mm A")
            : "N/A"}
        </dd>
      </div>
      {
        task?.date_closed && (
          <div className="sm:col-span-1">
            <dt className="text-sm font-medium text-gray-500">Closed At</dt>
            <dd className="mt-1 text-sm text-gray-900">
              { task?.date_closed
                ? moment(Number(task?.date_closed)).format("DD/MM/YYYY hh:mm A")
                : "N/A"}
            </dd>
          </div>
        )
      }
      {
        task?.date_done && (
          <div className="sm:col-span-1">
            <dt className="text-sm font-medium text-gray-500">Resolved At</dt>
            <dd className="mt-1 text-sm text-gray-900">
              { task?.date_done
                ? moment(Number(task?.date_done)).format("DD/MM/YYYY hh:mm A")
                : "N/A"}
            </dd>
          </div>
        )
      }
      <div className="col-start-1 sm:col-span-1">
        <dt className="text-sm font-medium text-gray-500">Created By</dt>
        <dd className="mt-1 text-sm text-gray-900">
          <div className={"flex items-center whitespace-nowrap px-6 py-4 text-sm text-gray-500"}>
            <div className="h-10 w-10 flex-shrink-0">
              <Avatar
                disabled={true}
                alt={task?.creator?.username || "N A"}
                src={task?.creator?.profilePicture || ""}
              />
            </div>
            <div className="ml-4">
              <div className="text-gray-900 dark:text-gray-100">
                {task?.creator?.username || "N A"}
              </div>
              <div className="text-gray-500 dark:text-gray-400">
                {task?.creator?.email || "N/A"}
              </div>
            </div>
          </div>
        </dd>
      </div>
    </dl>
  );
};

export default ClickupTaskView;
